

export const elaineReviewerReviewHinge = {
  _id: 'elaineReviewerReviewHingeId',
  email: 'elaine@email.com',
  profileReviewId: 'elaineProfileReviewHingeId',
  reviewerProfileId: 'elaineReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Elaine! This will really help me!',
  profileReviewedFirstName: 'George',
}

export const jerryReviewerReviewBumble = {
  _id: 'jerryReviewerReviewBumbleId',
  email: 'jerry@email.com',
  profileReviewId: 'jerryProfileReviewBumbleId',
  reviewerProfileId: 'jerryReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Jerry! This will really help me!',
  profileReviewedFirstName: 'George',
}

export const kramerReviewerReviewTinder = {
  _id: 'kramerReviewerReviewTinderId',
  email: 'kramer@email.com',
  profileReviewId: 'kramerProfileReviewTinderId',
  reviewerProfileId: 'kramerReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Kramer! This will really help me!',
  profileReviewedFirstName: 'George',
}